export const ColumnMinWidth = 60;
export const ColumnMaxWidth = 240;
export const DefaultColumnWidth = 120;
export const DefaultRowHeight = 39;
